export default function connectHandler(autoScrollHandler: () => void) {
    return (event: Event) => {
        setTimeout(() => {
            autoScrollHandler();
        }, 2000);
    };
}